import React from 'react';
import {
  TextField,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText
} from '@material-ui/core';
import NumberFormat from 'react-number-format';


const RequestPromotionDiscountBasicForm = ({
  values,
  handleChange,
  setFieldValue,
  touched,
  errors,
  classes
}) => {
  return (
    <>
      <FormControlLabel
        value="percentageOff"
        control={
          <Radio
            size="small"
            color="primary"
            onClick={() => setFieldValue('discountType.name', 'Percentage OFF')}
          />}
        label={
          <div className="flex items-center">
            <span>Percentage OFF</span>
            {values.discountType.value === 'percentageOff' &&
            <NumberFormat
              customInput={TextField}
              suffix={'%'}
              required
              allowNegative={false}
              size="small"
              label="Discount"
              variant="outlined"
              name="percentageOff.discount"
              className={`ml-4 max-w-100 ${classes.custom_input}`}
              value={values.percentageOff.discount}
              onValueChange={(value) => {
                setFieldValue('percentageOff.discount', value.formattedValue);
              }}
              error={touched.percentageOff?.discount && Boolean(errors.percentageOff?.discount)}
              helperText={touched.percentageOff?.discount && errors.percentageOff?.discount}
            />
            }
          </div>
        }
      />
      <FormControlLabel
        value="dollarOff"
        control={
          <Radio
            size="small"
            color="primary"
            onClick={() => setFieldValue('discountType.name', 'Dollar OFF')}
          />}
        label={
          <div className="flex items-center">
            <span>Dollar OFF</span>
            {values.discountType.value === 'dollarOff' &&
            <NumberFormat
              customInput={TextField}
              prefix={'$'}
              required
              size="small"
              label="Discount"
              variant="outlined"
              thousandsGroupStyle="thousand"
              thousandSeparator
              name="dollarOff.discount"
              className={`ml-4 max-w-100 ${classes.custom_input}`}
              value={values.dollarOff.discount}
              onValueChange={(value) => {
                setFieldValue('dollarOff.discount', value.formattedValue);
              }}
              error={touched.dollarOff?.discount && Boolean(errors.dollarOff?.discount)}
              helperText={touched.dollarOff?.discount && errors.dollarOff?.discount}
            />
            }
          </div>
        }
      />
      {values.discountType.value === 'dollarOff' &&
      <div className="my-4 ml-6 max-w-300">
        <RadioGroup
          name="dollarOff.discountTo"
          value={values.dollarOff.discountTo}
          onChange={handleChange}
        >
          <div className="flex flex-wrap justify-between">
            <FormControlLabel
              value="by_fixed"
              control={
                <Radio
                  size="small"
                  color="primary"
                />
              }
              label="Each Item"
            />
            <FormControlLabel
              value="cart_fixed"
              control={
                <Radio
                  size="small"
                  color="primary"
                />
              }
              label="Whole Cart"
            />
          </div>
        </RadioGroup>
        {touched.dollarOff?.discountTo && Boolean(errors.dollarOff?.discountTo) &&
        <FormHelperText>
          <Typography color="error" variant="caption">
            {errors.dollarOff.discountTo}
          </Typography>
        </FormHelperText>
        }
      </div>
      }
      <FormControlLabel
        value="fixedPrice"
        control={
          <Radio
            size="small"
            color="primary"
            onClick={() => setFieldValue('discountType.name', 'Fixed Price')}
          />}
        label={
          <div className="flex items-center">
            <span>Fixed Price</span>
            {values.discountType.value === 'fixedPrice' &&
            <NumberFormat
              customInput={TextField}
              prefix={'$'}
              required
              size="small"
              label="Price"
              variant="outlined"
              name="fixedPrice.price"
              thousandsGroupStyle="thousand"
              thousandSeparator
              className={`ml-4 max-w-100 ${classes.custom_input}`}
              value={values.fixedPrice.price}
              onValueChange={(value) => {
                setFieldValue('fixedPrice.price', value.formattedValue);
              }}
              error={touched.fixedPrice?.price && Boolean(errors.fixedPrice?.price)}
              helperText={touched.fixedPrice?.price && errors.fixedPrice?.price}
            />
            }
          </div>
        }
      />
    </>
  );
};

export default RequestPromotionDiscountBasicForm;
